import { supabase } from "@/integrations/supabase/client";
import type { RealtimeChannel } from "@supabase/supabase-js";

let counter = 0;

/**
 * Subscribe to postgres changes on a channel with a guaranteed-unique name.
 *
 * Reusing a channel name causes supabase-js to hand back the existing channel,
 * and attaching `postgres_changes` callbacks to an already-subscribed channel
 * throws ("cannot add `postgres_changes` callbacks ... after `subscribe()`"),
 * which used to bubble up into the route error boundary.
 */
export function subscribeToTable(
  prefix: string,
  filter: {
    event: "*" | "INSERT" | "UPDATE" | "DELETE";
    schema: string;
    table: string;
    filter?: string;
  },
  onChange: () => void,
): () => void {
  let channel: RealtimeChannel | null = null;
  try {
    counter += 1;
    channel = supabase
      .channel(`${prefix}-${counter}-${Math.random().toString(36).slice(2, 8)}`)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .on("postgres_changes" as any, filter as any, () => {
        try {
          onChange();
        } catch {
          /* ignore consumer errors */
        }
      })
      .subscribe();
  } catch (err) {
    console.warn("realtime subscribe failed", err);
    channel = null;
  }
  return () => {
    if (!channel) return;
    try {
      void supabase.removeChannel(channel);
    } catch {
      /* ignore */
    }
  };
}
